module.exports = __webpack_public_path__ + "static/media/navbar-ico-1.b4057aee.svg";